const AUTH_TYPES = Object.freeze({
    STORAGE_AUTH_PARAM_NAME: 'auth_token',
    STORAGE_AUTH_CNPJ_PARAM_NAME: 'auth_cnpj',
    STORAGE_SELLER_ID_PARAM_NAME: 'seller_id',
    URL_AUTH_SELLER_ID_PARAM_NAME: 'seller_id',
    URL_AUTH_PARAM_NAME: 'cgv_web_token',
    URL_AUTH_CNPJ_PARAM_NAME: 'cgv_web_cnpj',
});

export { AUTH_TYPES };